module.exports = __webpack_public_path__ + "img/1484032919.8c2be613.jpg";